const hexToRgba = (hex, opacity) => {
  if (!hex) return `rgba(14, 12, 26, ${opacity})`;

  const value = hex.replace("#", "");

  const r = parseInt(value.substring(0, 2), 16);
  const g = parseInt(value.substring(2, 4), 16);
  const b = parseInt(value.substring(4, 6), 16);

  return `rgba(${r}, ${g}, ${b}, ${opacity})`;
};

export default hexToRgba;